import { useState, useEffect } from "react";

export const useCalculateComponentHeightSizeHook = ({ heightDifference = 300, containerRef = null } = {}) => {
	const [tableHeight, setTableHeight] = useState(400);

	useEffect(() => {
		const updateTableHeight = () => {
			let desiredHeight = 400;

			if (containerRef?.current) {
				desiredHeight = containerRef.current.clientHeight - heightDifference;
			} else {
				desiredHeight = window.innerHeight - heightDifference;
			}

			setTableHeight(desiredHeight > 300 ? desiredHeight : 300);
		};

		let observer;
		if (containerRef?.current) {
			observer = new ResizeObserver(updateTableHeight);
			observer.observe(containerRef.current);
		}

		updateTableHeight();
		window.addEventListener("resize", updateTableHeight);		

		return () => {
			window.removeEventListener("resize", updateTableHeight);
			if (observer) observer.disconnect(); // Stop observing when unmounting
		};
	}, [heightDifference, containerRef]);

	return {
		tableHeight
	};
};
